var React = require('react');

function IntroPolyclusterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M208.696 106.537L178.892 121.576L180.769 88.2456L208.696 106.537Z","stroke":"#C99CEF","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M10.0678 118.655L15.7308 127.035L5.64137 127.749L10.0678 118.655Z","stroke":"#C99CEF","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M80.0604 8.70258L100.095 13.2563L86.1339 28.3299L80.0604 8.70258Z","fill":"#B1F8FC","key":2})]);
}

IntroPolyclusterInline.defaultProps = {"width":"219","height":"135","viewBox":"0 0 219 135","fill":"none"};

module.exports = IntroPolyclusterInline;

IntroPolyclusterInline.default = IntroPolyclusterInline;
